export class AppNumberInput extends HTMLElement {
  static get observedAttributes() {
    return ["label", "value", "unit", "min", "max", "step", "precision", "disabled", "required", "error", "helper"];
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback() {
    this.render();
  }

  get value(): number | null {
    const input = this.querySelector("input");
    if (!input || input.value === "") return null;
    return parseFloat(input.value);
  }

  set value(val: number | null) {
    const input = this.querySelector("input");
    if (input) {
      input.value = val !== null ? val.toString() : "";
    }
  }

  private render() {
    const label = this.getAttribute("label") || "";
    const value = this.getAttribute("value") || "";
    const unit = this.getAttribute("unit") || "";
    const min = this.getAttribute("min") || "";
    const max = this.getAttribute("max") || "";
    const step = this.getAttribute("step") || "any";
    const disabled = this.hasAttribute("disabled");
    const required = this.hasAttribute("required");
    const error = this.getAttribute("error") || "";
    const helper = this.getAttribute("helper") || "";

    const id = `num-input-${Math.random().toString(36).substring(2, 9)}`;

    this.innerHTML = `
      <div class="form-group">
        ${label ? `<label for="${id}" class="form-label ${required ? "required" : ""}">${label}</label>` : ""}
        <div style="position: relative; display: flex; align-items: center;">
          <input
            id="${id}"
            type="number"
            class="form-input ${error ? "error" : ""}"
            style="font-family: var(--font-mono); ${unit ? "padding-right: 48px;" : ""}"
            value="${value}"
            ${min ? `min="${min}"` : ""}
            ${max ? `max="${max}"` : ""}
            step="${step}"
            ${disabled ? "disabled" : ""}
            ${required ? "required" : ""}
          />
          ${unit ? `<span style="position: absolute; right: 12px; font-family: var(--font-mono); font-size: 0.75rem; color: var(--color-text-muted); pointer-events: none;">${unit}</span>` : ""}
        </div>
        ${error ? `<span class="form-error">${error}</span>` : ""}
        ${helper && !error ? `<span class="form-helper">${helper}</span>` : ""}
      </div>
    `;
  }
}

if (!customElements.get("app-number-input")) {
  if (!customElements.get("app-number-input")) {
    customElements.define("app-number-input", AppNumberInput);
  }
}
